import { gql } from '../../../../../../hooks'

export const UPLOAD_TO_S3 = gql`
  mutation UploadToS3($file: Upload!, $bucketKey: String) {
    uploadToS3(file: $file, bucketKey: $bucketKey) {
    }
  }
`
